import script from "./AppIntegrationComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppIntegrationComponent.vue?vue&type=script&lang=ts&setup=true"

import "./AppIntegrationComponent.vue?vue&type=style&index=0&id=284f1eae&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-284f1eae"]])

export default __exports__